import { render } from "./NotFound.vue?vue&type=template&id=59819957&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=59819957&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-59819957"

export default script